import { exportSurveys } from '@/services/surveys-service/surveys-service';
import { SurveysFilters } from '@/services/surveys-service/surveys-service.types';
import { message } from 'antd';
import { useState } from 'react';

interface UseExportSurveysHistoryProps {
  params: SurveysFilters;
}

export const useExportSurveysHistory = ({ params }: UseExportSurveysHistoryProps) => {
  const [isPending, setIsPending] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const exportSurveysHistory = async () => {
    try {
      setIsPending(true);
      const csvContent = await exportSurveys(params);

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `exported_surveys_${new Date().toISOString().split('T')[0]}.csv`
      );
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      messageApi.success('File has been downloaded successfully!');
    } catch (error) {
      messageApi.error('Failed to download the file');
      console.error('Export error:', error);
    } finally {
      setIsPending(false);
    }
  };

  return { exportSurveysHistory, isPending, exportContextHolder: contextHolder };
};
